<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2f"><a id="pix"></a><span epub:type="pagebreak" id="pageix" title="ix"><a id="list"></a>List of illustrations</span></h2>
<p class="list">Proclamation issued at the height of the disturbances, 1847</p>
<p class="list">In famine times, children were often said to be ‘in rags’</p>
<p class="list">A house of the sort seen throughout the Hebrides at the time</p>
<p class="list">Irish famine victims, West Cork</p>
<p class="list">The lodge by Loch Laggan</p>
<p class="list">Fishing boats in Pulteneytown Harbour, Wick</p>
<p class="list">A procession in Pulteneytown’s Union Street</p>
<p class="list">Bridge Street, Wick, the scene of repeated protests</p>
<p class="list">Inverness Town Hall</p>
<p class="list">Herring gutters at work</p>
<p class="list">Homes of the type occupied by many of the rioters</p>
<p class="list">A street scene in Cromarty, where people protested at the soaring food prices</p>
<p class="list">Rhynie Farm, Easter Ross</p>
<p class="list">Findhorn Harbour</p>
<p class="list">A Lossiemouth fishwife</p>
<p class="list">The grain storehouse at Foulis Point, near Dingwall</p>
<p class="list">Hopeman was home to many of those involved in the Burghead riots</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// list.vue?339e7b70